export const columns = function () {
  // 机构名称，出单个数，出单金额，退单个数，退单金额
  return [
    {
      prop: "orgName",
      label: "机构名称",
      minWidth: 200,
    },
    {
      prop: "outNum",
      label: "出单个数",
      minWidth: 100,
    },
    {
      prop: "outAmount",
      label: "出单金额",
      minWidth: 100,
    },
    {
      prop: "returnCount",
      label: "退单个数",
      minWidth: 100,
    },
    {
      prop: "returnAmount",
      label: "退单金额",
      minWidth: 100,
    },
  ];
};

export default {};
